export default {
  CREATED: 'created',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};
